export default "__VITE_ASSET__Da_dQEK0__"